import { useEffect } from "react";
import AgeGate from "../components/AgeGate";
import Nav from "../components/Nav";
import TourBanner from "../components/TourBanner";
import Hero from "../sections/Hero";
import About from "../sections/About";
import Gallery from "../sections/Gallery";
import Rates from "../sections/Rates";
import Booking from "../sections/Booking";
import OnlyFans from "../sections/OnlyFans";
import Testimonials from "../sections/Testimonials";
import FAQ from "../sections/FAQ";
import Footer from "../sections/Footer";
import ChatWidget from "../components/ChatWidget";
import { useSite } from "../context/SiteContext";

function useReveal() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document
      .querySelectorAll("section > div, .card-luxe, .wm-wrap")
      .forEach((el) => {
        el.classList.add("reveal");
        io.observe(el);
      });
    return () => io.disconnect();
  }, []);
}

function useGalleryGuards() {
  useEffect(() => {
    const onCtx = (e) => {
      const t = e.target;
      if (t && t.tagName === "IMG") e.preventDefault();
    };
    document.addEventListener("contextmenu", onCtx);
    return () => document.removeEventListener("contextmenu", onCtx);
  }, []);
}

function useSeo() {
  const { content } = useSite();
  useEffect(() => {
    if (content?.seo_title) document.title = content.seo_title;
    if (content?.seo_description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", content.seo_description);
      const og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute("content", content.seo_description);
      const tw = document.querySelector('meta[name="twitter:description"]');
      if (tw) tw.setAttribute("content", content.seo_description);
    }
    if (content?.seo_title) {
      const og = document.querySelector('meta[property="og:title"]');
      if (og) og.setAttribute("content", content.seo_title);
      const tw = document.querySelector('meta[name="twitter:title"]');
      if (tw) tw.setAttribute("content", content.seo_title);
    }
    // Sync og:url / twitter:url / og:image / twitter:image / canonical to the
    // production site URL from env so social preview crawlers always see the
    // canonical domain regardless of which environment served the HTML — and
    // so a build that failed to substitute %REACT_APP_SITE_URL% is still fixed
    // at runtime.
    const siteUrl = process.env.REACT_APP_SITE_URL;
    if (siteUrl) {
      const base = siteUrl.replace(/\/$/, "");
      const url = `${base}/`;
      const image = `${base}/og-image.jpg`;
      const setContent = (sel, val) => {
        const el = document.querySelector(sel);
        if (el) el.setAttribute("content", val);
      };
      setContent('meta[property="og:url"]', url);
      setContent('meta[name="twitter:url"]', url);
      setContent('meta[property="og:image"]', image);
      setContent('meta[name="twitter:image"]', image);
      let can = document.querySelector('link[rel="canonical"]');
      if (!can) {
        can = document.createElement("link");
        can.setAttribute("rel", "canonical");
        document.head.appendChild(can);
      }
      can.setAttribute("href", url);
    }
  }, [content?.seo_title, content?.seo_description]);
}

export default function PublicSite() {
  useReveal();
  useGalleryGuards();
  useSeo();
  return (
    <>
      <AgeGate />
      <TourBanner />
      <Nav />
      <main>
        <Hero />
        <div className="hairline my-2" />
        <About />
        <div className="hairline my-2" />
        <Gallery />
        <div className="hairline my-2" />
        <Rates />
        <div className="hairline my-2" />
        <Booking />
        <div className="hairline my-2" />
        <OnlyFans />
        <div className="hairline my-2" />
        <Testimonials />
        <div className="hairline my-2" />
        <FAQ />
      </main>
      <Footer />
      <ChatWidget />
    </>
  );
}
